
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3.333-14.444A3.329 3.329 0 0012 4.222a3.329 3.329 0 00-3.333 3.334A3.329 3.329 0 0012 10.889a3.329 3.329 0 003.333-3.333zM8.217 19.049a8 8 0 0010.45-2.627C18.633 14.212 14.21 13 12 13c-2.222 0-6.633 1.211-6.667 3.422a8 8 0 002.884 2.627z"}})])
          )
        }
      }
    